import { Box, Container, Paper } from '@mui/material';
import { Result } from '@opengov/components-result';
import { capitalDesignTokens } from '@opengov/capital-mui-theme';

interface LoadingErrorPageProps {
  error: Error;
  onRetry: () => void;
}

/**
 * LoadingErrorPage component for displaying errors when remote applications fail to load.
 * Displays an error message with a retry button in an elevated paper container.
 */
export function LoadingErrorPage({ error, onRetry }: LoadingErrorPageProps) {
  return (
    <Box
      sx={{
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${capitalDesignTokens.semanticColors.background.secondary} 0%, ${capitalDesignTokens.semanticColors.background.tertiary} 100%)`,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          role="alert"
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 2,
            background: capitalDesignTokens.semanticColors.background.primary,
          }}
        >
          <Result
            title="Failed to load application"
            subTitle={error.message}
            size="large"
            status="error"
            actionButtons={[{ label: 'Try Again', onClick: onRetry }]}
          />
        </Paper>
      </Container>
    </Box>
  );
}
